module.exports = __webpack_public_path__ + "static/media/feedSolutionsblue.cc047405.svg";